module.exports = __webpack_public_path__ + "img/index-new-02.a942b033.svg";